import { useNavigate } from 'react-router';

import { Button } from '@/components/ui';

export function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="font-mono text-sm text-content-subtle">403</p>
      <h1 className="mt-2 text-lg font-semibold text-content">You do not have access</h1>
      <p className="mt-1 max-w-sm text-sm text-content-muted">
        Your account does not have permission to view this page. Contact your administrator if you
        think this is a mistake.
      </p>
      <Button
        variant="secondary"
        size="md"
        className="mt-5"
        onClick={() => {
          void navigate('/');
        }}
      >
        Back to safety
      </Button>
    </div>
  );
}
